/**
 * A tenant-wide banner shown to every user while their organization is in
 * maintenance mode (tenants.maintenance_mode). Explains why Lumen actions
 * (provision / modify / disconnect) are paused / returning 503. The flag rides
 * on the /auth/me profile (useAuth().user.maintenance_mode), so it appears for
 * all roles, not just admins who can read tenant settings.
 */
import { Alert } from "react-bootstrap";

import { useAuth } from "@/auth/useAuth";

export function MaintenanceBanner() {
  const { user } = useAuth();
  if (!user?.maintenance_mode) return null;
  return (
    <Alert variant="warning" className="mb-0 rounded-0 text-center py-2">
      <strong>Maintenance mode is active.</strong> Lumen operations (provisioning,
      bandwidth changes, disconnects) are paused for your organization and will
      resume when maintenance is turned off.
    </Alert>
  );
}
